import React__default from 'react';
import { StockIndicator } from '@grandvisionhq/inventory';
import { useProductData } from '../../../../context/product-context-hooks.js';

const ProductStockIndicator = ()=>{
    const { activeVariant: { stock , channelAvailability  } ,  } = useProductData();
    return /*#__PURE__*/ React__default.createElement(StockIndicator, {
        stockCount: stock.stockCount,
        allowBackOrder: stock.isAllowBackOrder,
        channelAvailability: channelAvailability
    });
};

export { ProductStockIndicator };
//# sourceMappingURL=ProductStockIndicator.js.map
